import { VueModule } from '@Foundation/utilities';
import safeSpace from './code/Scripts/components/safe-space';

export default VueModule({
  components: {
    safeSpace
  }
});
